import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const AIFPrivateRoute = () => {
const isAuthenticated = useSelector((state) => state.myreducer.isAuthenticated)


  
    if (isAuthenticated) {
      return <Outlet />;
    } else {
      return <Navigate to="/AIF/login" />;
    }
}

export default AIFPrivateRoute